import { css } from '@emotion/react';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { ACCORDION_HEADER_SIZE_LARGE } from '~/_shared/baseComponents/accordion';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';
import { BASIC_PANEL_WIDTH } from '~/sidebar/sidebarApps/rightSidebar/rightSidebarContent.constants';
import { SidebarMapKeyTabsContainer } from '~/sidebar/sidebarApps/rightSidebar/sidebarTabs/sidebarMapKeyTabs.container';
import { DEFAULT_TAB_HEIGHT } from '../tabs/tab.component';

export const LOCATION_DESCRIPTION_HEADER_HEIGHT = ACCORDION_HEADER_SIZE_LARGE;
const WITH_TABS_TITLE_HEIGHT = LOCATION_DESCRIPTION_HEADER_HEIGHT - DEFAULT_TAB_HEIGHT;

const headerStyle = css({
  display: 'flex',
  flexDirection: 'column',
});

const titleStyle = (theme: Theme) => css({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.backgroundColors.secondaryAlternative,
  borderBottom: '1px solid ' + theme.lineColors.basePrimary,
  boxSizing: 'border-box',
  fontSize: 20,
  fontWeight: 500,
  padding: '8px 8px 8px 0',
});

const headerIconStyle = (theme: Theme) => css({
  color: theme.textColors.primary,
  margin: '0 8px',
  '&:hover': {
    color: theme.iconColors.contrast,
  },
});

const headerDescriptionStyle = css({
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
  marginLeft: '15px',
  textTransform: 'uppercase',
});

type LocationListingHeaderProps = Readonly<{
  title?: string;
  showTabs?: boolean;
  onCloseClick: () => void;
}>;

export const LocationListingHeaderComponent: React.FC<LocationListingHeaderProps> = props => {
  const [t] = useTranslation();
  return (
    <div
      css={headerStyle}
      style={{ minWidth: BASIC_PANEL_WIDTH, height: ACCORDION_HEADER_SIZE_LARGE }}
    >
      <div
        style={{ minWidth: BASIC_PANEL_WIDTH, height: props.showTabs ? WITH_TABS_TITLE_HEIGHT : LOCATION_DESCRIPTION_HEADER_HEIGHT }}
        css={titleStyle}
      >
        <span css={headerDescriptionStyle}>
          {props.title && !props.showTabs && props.title}
        </span>
        <FontAwesomeIcon
          css={headerIconStyle}
          icon={faXmark}
          onClick={props.onCloseClick}
          title={t('Close')}
        />
      </div>
      {props.showTabs &&
        <SidebarMapKeyTabsContainer />
      }
    </div>
  );
};
